import { Stack } from "@mui/material";
import { MenuRender } from "../MenuRender/MenuRender";
import { Category, Restaurant } from "../../../interfaces/Catalogue";
import styles from "./MenuSections.module.scss";

interface Props {
  categories: Category[];
  restaurant?: Restaurant;
  userLoyalityPoints: number;
  sectionRefs: React.MutableRefObject<(HTMLElement | null)[]>;
}

const MenuSections = ({ categories, restaurant, userLoyalityPoints, sectionRefs }: Props) => (
  <Stack className="menuGrid" spacing={4} direction="column" sx={{ marginTop: "2rem" }}>
    {categories?.map((category, i) => (
      <Stack
        className="menuSection full-width menuSectionContainer"
        key={category.id || i}
        ref={(el: HTMLElement | null) => (sectionRefs.current[i] = el)}
        id={`menuSection${i}`}
        spacing={2}
        sx={{ scrollMarginTop: "250px" }}
      >
        <div className={styles.nameCat}>
          <p>{category.designation.toLowerCase()}</p>
        </div>
        <MenuRender
          category={category}
          restaurant={restaurant}
          userLoyalityPoints={userLoyalityPoints}
        />
      </Stack>
    ))}
  </Stack>
);

export default MenuSections;